import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { SSRExperimentsProvider } from '../../context';
import { OverlayProvider } from '../../context/Overlay';
import { DiscoverState, ExperimentMap } from '../../types';

type SearchPageProvidersProps = {
    store: Store<DiscoverState>;
    location: Location;
    experiments: ExperimentMap | undefined;
    children: React.ReactNode;
};

export function SearchPageProviders({
    store,
    location,
    experiments,
    children,
}: SearchPageProvidersProps) {
    return (
        <Provider store={store}>
            <SSRExperimentsProvider
                location={location}
                experiments={experiments}
            >
                <OverlayProvider>{children}</OverlayProvider>
            </SSRExperimentsProvider>
        </Provider>
    );
}
